import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { FEEDBACK_FORM_ACTION_TYPES } from './FeedbackFormStateReducer';
import { REPORTING_AI_ASSISTANT_FEEDBACK_TYPE } from './feedbackConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const POSITIVE_FEEDBACK_KEYS = ['newInfo', 'helpedBusiness', 'helpedAnswerQuestion'];
const NEGATIVE_FEEDBACK_KEYS = ['inaccurate', 'irrelevant', 'obvious'];
const FeedbackPopoverBody = ({
  feedbackType,
  state,
  dispatch
}) => {
  const radioButtonKeys = feedbackType === REPORTING_AI_ASSISTANT_FEEDBACK_TYPE.POSITIVE ? POSITIVE_FEEDBACK_KEYS : NEGATIVE_FEEDBACK_KEYS;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsx(ToggleGroup, {
        name: "reporting-ai-positive-feedback-group",
        children: radioButtonKeys.map(key => /*#__PURE__*/_jsx(Checkbox, {
          "data-test-id": `reporting-ai-assistant-feedback-${key}`,
          checked: key in state.checkboxInputFeedback,
          onChange: () => dispatch({
            type: FEEDBACK_FORM_ACTION_TYPES.SET_CHECKBOX_FEEDBACK,
            payload: key
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `reporting-enablement.platformReport.reportVisualizationInsights.feedback.${feedbackType}.options.${key}`
          })
        }, key))
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('reporting-enablement.platformReport.reportVisualizationInsights.feedback.other'),
      children: /*#__PURE__*/_jsx(TextArea, {
        "data-test-id": "reporting-ai-assistant-feedback-other",
        value: state.otherFeedback,
        onChange: ({
          target: {
            value
          }
        }) => {
          dispatch({
            type: FEEDBACK_FORM_ACTION_TYPES.SET_OTHER_FEEDBACK,
            payload: value
          });
        }
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: state.contactMe,
        onChange: ({
          target: {
            checked
          }
        }) => dispatch({
          type: FEEDBACK_FORM_ACTION_TYPES.SET_CONTACT_ME,
          payload: checked
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.platformReport.reportVisualizationInsights.feedback.contactMe"
        })
      })
    })]
  });
};
export default FeedbackPopoverBody;